<template>
  <div class="scheduled-courses-page">
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/tinternalcourses/dashboard"
          >Training Dashboard</router-link
        >
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Scheduled Internal Courses
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-1">
          <router-link
            to="/tinternalcourses/dashboard"
            class="btn btn-sm btn-outline-primary bdr-rad font-size_def"
            >Back</router-link
          >
        </div>
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="scheduled-section-title">Search</div>
            <div class="row px-2 pt-2">
              <div class="col-md-4 mb-2">
                <label>Main Course</label>
                <select
                  v-model="filters.category"
                  class="form-control form-control-sm bdr-rad"
                >
                  <option value="">Select</option>
                  <option
                    v-for="category in categories"
                    :key="category"
                    :value="category"
                  >
                    {{ category }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 mb-2">
                <label>Course</label>
                <select
                  v-model="filters.course_id"
                  class="form-control form-control-sm bdr-rad"
                >
                  <option value="">Select...</option>
                  <option
                    v-for="course in filteredCourses"
                    :key="course.id"
                    :value="course.id"
                  >
                    {{ course.course_title }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 mb-2">
                <label>Module</label>
                <select
                  v-model="filters.module_id"
                  class="form-control form-control-sm bdr-rad"
                >
                  <option value="">Select...</option>
                  <option
                    v-for="module in filterModules"
                    :key="module.id"
                    :value="module.id"
                  >
                    {{ module.module_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="d-flex justify-content-end px-2 pb-2">
              <button
                type="button"
                class="btn btn-sm btn-primary bdr-rad mr-2 font-size_def"
                @click="loadSchedules"
              >
                Search
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary bdr-rad font-size_def"
                @click="resetFilters"
              >
                Reset
              </button>
            </div>
          </div>
        </div>
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>
            <div v-if="successMessage" class="alert alert-success">
              {{ successMessage }}
            </div>
            <div
              class="d-flex justify-content-between align-items-center px-2 py-2"
            >
              <span class="text-muted small"
                >Showing {{ items.length }} items.</span
              >
            </div>
            <div v-if="isLoading" class="d-flex justify-content-center py-4">
              <div class="spinner-border text-primary"></div>
            </div>
            <div v-else class="table-responsive">
              <table class="table table-sm table-hover scheduled-table mb-0">
                <thead>
                  <tr>
                    <th>Main Course</th>
                    <th>Class Code</th>
                    <th>Course</th>
                    <th>Allocated Slots</th>
                    <th>Class Date</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Status</th>
                    <th class="actions-col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>{{ item.course_category || "-" }}</td>
                    <td>{{ item.course_code }}</td>
                    <td>
                      {{ item.course_title }}
                      <div class="text-muted module-name">
                        {{ item.module_name }}
                      </div>
                    </td>
                    <td>{{ item.allocated_slots }}</td>
                    <td>{{ formatDate(item.class_date) }}</td>
                    <td>{{ item.start_time || "-" }}</td>
                    <td>{{ item.end_time || "-" }}</td>
                    <td>{{ item.status }}</td>
                    <td class="actions-cell">
                      <div class="dropdown">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Action
                        </button>
                        <div class="dropdown-menu bdr-rad">
                          <a
                            class="dropdown-item mouse-cursor"
                            @click="viewSchedule(item.id)"
                            >View</a
                          >
                          <a
                            class="dropdown-item mouse-cursor"
                            @click="updateSchedule(item.id)"
                            >Update</a
                          >
                          <a
                            class="dropdown-item mouse-cursor"
                            @click="cancelSchedule(item)"
                            >Cancel</a
                          >
                          <a
                            class="dropdown-item mouse-cursor"
                            @click="viewCourse(item.course_id)"
                            >Attendance Sheet</a
                          >
                          <a
                            class="dropdown-item mouse-cursor"
                            @click="viewSurveyForm(item.id)"
                            >View Survey Form</a
                          >
                          <a
                            class="dropdown-item mouse-cursor"
                            @click="trainingAssessment(item.id)"
                            >Training Assessment</a
                          >
                          <a
                            class="dropdown-item mouse-cursor"
                            @click="createSurveyForm(item.id)"
                            >Create Survey Form</a
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!items.length">
                    <td colspan="9" class="text-center text-muted py-4">
                      No scheduled internal courses found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <employee-training-requirements></employee-training-requirements>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";
import EmployeeTrainingRequirements from "./EmployeeTrainingRequirements.vue";

export default {
  components: { TopNavbar, ContentFooter, EmployeeTrainingRequirements },
  data() {
    return {
      token: authService.isLoggedIn(),
      isLoading: true,
      errorMessage: "",
      successMessage: "",
      items: [],
      categories: [],
      courses: [],
      filters: { category: "", course_id: "", module_id: "" },
    };
  },
  computed: {
    filteredCourses() {
      return this.courses.filter(
        (course) =>
          !this.filters.category ||
          course.training_category === this.filters.category
      );
    },
    filterModules() {
      const course = this.courses.find(
        (item) => Number(item.id) === Number(this.filters.course_id)
      );
      return course
        ? course.modules || []
        : this.courses.reduce(
            (all, item) => all.concat(item.modules || []),
            []
          );
    },
  },
  mounted() {
    this.loadSchedules();
  },
  methods: {
    async loadSchedules() {
      this.isLoading = true;
      this.errorMessage = "";
      try {
        const params = {};
        if (this.filters.category) params.category = this.filters.category;
        if (this.filters.course_id) params.course_id = this.filters.course_id;
        if (this.filters.module_id) params.module_id = this.filters.module_id;
        const { data } = await axios.get("/ticourses/schedules", {
          params,
          headers: { Authorization: "Bearer " + this.token },
        });
        this.items = data.data || [];
        this.categories = data.categories || [];
        this.courses = data.courses || [];
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            (error.response.data.message || error.response.data.name)) ||
          "Unable to load scheduled internal courses.";
      } finally {
        this.isLoading = false;
      }
    },
    resetFilters() {
      this.filters = { category: "", course_id: "", module_id: "" };
      this.loadSchedules();
    },
    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value + "T00:00:00");
      return [
        String(date.getDate()).padStart(2, "0"),
        String(date.getMonth() + 1).padStart(2, "0"),
        date.getFullYear(),
      ].join("-");
    },
    viewCourse(id) {
      this.$router.push("/tinternalcourses/view?id=" + id);
    },
    viewSchedule(id) {
      this.$router.push("/tinternalcourses/scheduled/view?id=" + id);
    },
    updateSchedule(id) {
      this.$router.push("/tinternalcourses/scheduled/update?id=" + id);
    },
    viewSurveyForm(id) {
      this.$router.push("/tinternalcourses/scheduled/survey?schedule_id=" + id);
    },
    trainingAssessment(id) {
      this.$router.push("/tinternalcourses/scheduled/assessment?id=" + id);
    },
    createSurveyForm(id) {
      this.$router.push("/tinternalcourses/scheduled/create-survey?schedule_id=" + id);
    },
    async cancelSchedule(item) {
      if (
        !window.confirm(
          "Are you sure you want to cancel this scheduled course?"
        )
      )
        return;
      try {
        await axios.post(
          "/ticourses/cancel-schedule?id=" + item.id,
          {},
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.successMessage = "Scheduled course cancelled successfully.";
        await this.loadSchedules();
      } catch (error) {
        this.errorMessage = "Unable to cancel scheduled course.";
      }
    },
  },
};
</script>

<style>
.scheduled-courses-page .bdr-rad {
  border-radius: 12px;
}

.scheduled-courses-page .bdr-rad2 {
  border-radius: 15px;
}

.scheduled-courses-page .decoration {
  text-decoration: none;
  color: #fff !important;
}

.scheduled-courses-page .font1 {
  font-size: 13px !important;
}

.scheduled-courses-page .manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.scheduled-courses-page label {
  display: block;
  color: #000;
  font-size: small;
}

.scheduled-courses-page .form-control {
  color: #000;
  background-color: #fff;
  border-color: #ced4da;
}

.scheduled-courses-page .scheduled-section-title {
  margin: 0;
  padding: 5px 10px;
  color: #235983;
  background: #d9edf7;
  font-size: small;
  font-weight: 600;
}

.scheduled-courses-page .scheduled-table {
  font-size: small;
}

.scheduled-courses-page .scheduled-table thead th {
  height: 30px;
  padding: 0.3rem 0.5rem;
  border-top: 0;
  border-bottom: 2px solid #343a40;
  color: #000;
  background: #e7f5fc;
  white-space: nowrap;
}

.scheduled-courses-page .scheduled-table tbody tr,
.scheduled-courses-page .scheduled-table tbody tr:nth-child(odd),
.scheduled-courses-page .scheduled-table tbody tr:nth-child(even) {
  background: #fff;
}

.scheduled-courses-page .scheduled-table td {
  vertical-align: middle;
  white-space: nowrap;
}

.scheduled-courses-page .scheduled-table .btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.scheduled-courses-page .actions-col {
  min-width: 130px;
}

.scheduled-courses-page .actions-cell {
  white-space: normal;
}

.scheduled-courses-page .mouse-cursor {
  cursor: pointer;
}

.scheduled-courses-page .module-name {
  font-size: 11px;
}
</style>
